import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";
import Select from "react-select";
import ConfirmDialog from '../../../components/ConfirmDialog';

function Setting() {

  const [showForm, setShowForm] = useState(false);
  const [partyMaster, setPartyMaster] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [sources, setSources] = useState(["Online", "Store"]);
  const [showSourceModal, setShowSourceModal] = useState(false);
  const [newSourceName, setNewSourceName] = useState("");
  const [stateOptions, setStateOptions] = useState([]);
  const [address, setAddress] = useState([]);
  const [coupon, setCoupon] = useState([]);

  const [form, setForm] = useState({
   setting_key: '',
   description: '',
    value: '',
     checked:0
   
  })

  const [searchTerm, setSearchTerm] = useState('');

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };



  const handleAddClick = () => {
    setShowForm(true);
  };



const handleInputChange = (e) => {
  const { name, type, value, checked } = e.target;

  setForm((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? (checked ? 1 : 0) : value
  }));
};



 const handleSubmit = async (e) => {
  e.preventDefault();

  try {

    const payload = {
      setting_key: form.setting_key,
      description: form.description,
      value: form.value,
      checked: form.checked
    };

    if (isEditMode) {

      await axios.put(
        `https://api.skyguard.group/api/update-setting/${form.id}`,
        payload
      );

      showToast("Setting updated successfully", "success");

    } else {

      await axios.post(
        "https://api.skyguard.group/api/add-setting",
        payload
      );

      showToast("Setting added successfully", "success");
    }

    fetchSetting();

    setShowForm(false);
    setIsEditMode(false);

    setForm({
      setting_key: "",
      description: "",
      value: "",
      checked: 0
    });

  } catch (err) {

    console.error(err);

    showToast(
      isEditMode
        ? "Failed to update setting"
        : "Failed to add setting",
      "danger"
    );
  }
};



  const fetchSetting = async () => {
    try {
      const res = await axios.get("https://api.skyguard.group/api/fetch-setting");
      setCoupon(res.data);

    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };



  useEffect(() => {
    fetchSetting();
  }, []);




const handleEdit = (item) => {

  setForm({
    id: item.id,
    setting_key: item.setting_key || '',
    description: item.description || '',
    value: item.value || '',
    checked: Number(item.checked) || 0
  });

  setEditingCompanyId(item.id);
  setIsEditMode(true);
  setShowForm(true);
};


  const filteredData = coupon.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )
  

  return (
      <div className='main-section'>
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <h3 className='my-3 fw-bold fs-5 golos'>Setting</h3>



        <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

          <div className="mb-2 w-50 w-md-50 pe-md-2">
            <input
              className="form-control w-100"
              list="datalistOptions"
              placeholder="Search ...."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="mb-2">
            <button className="btn btn-success" onClick={handleAddClick}>
              <AiOutlinePlusCircle size={20} /> Add
            </button>
          </div>
        </div>


        {showForm && (


          <div className='card p-3 mb-3  w-75 mx-auto'>
            <form onSubmit={handleSubmit} >

                      {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {form.setting_key}
    </span>
  </div>
)}

              <hr />

              <div className='row g-3'>

                <div className="col-md-6">
                  <label htmlFor='name' className="form-label fw-medium" > Setting Key  </label>
                  <input type="text" className="form-control" name="setting_key" placeholder="Enter here..." value={form.setting_key} onChange={handleInputChange} required />
                </div>

                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" > Description </label>
                  <input type="text" className="form-control" name="description" placeholder="Enter here..."
                    value={form.description}
                    onChange={handleInputChange}
                 
                  />
                </div>



              



                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" >Value</label>
                  <input type="text" className="form-control" name="value" placeholder="Enter here..."
                    value={form.value}
                    onChange={handleInputChange}

                  />
                </div>

               

         <div className="col-md-6">
  <label className="form-label fw-medium">Is Active</label>

  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      name="checked"
       checked={Number(form.checked) === 1}
      onChange={handleInputChange}
    />

    
  </div>
</div>
                <div className='gap-2 d-flex justify-content-center mt-4'>
                  <button type="submit" className='btn btn-success w-10'>
                    {isEditMode ? "Update" : "Save"}
                  </button>
                  <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                    setShowForm(false);
                    setIsEditMode(false);
                    setForm({
                       setting_key: '',
   description: '',
    value: '',
     checked:''
                    })
                  }}>
                    Cancel
                  </button>
                </div>

              </div>
            </form>
          </div>
        )}




        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>

            <thead className='table-info'>
              <tr>
                   <th scope='col'>SN</th>
                    <th scope='col'>Action</th>
             
                <th>Setting Key</th>
<th>Description</th>
<th>Value</th>
<th>Status</th>
           

            
              </tr>
            </thead>
      
              <tbody>
  {filteredData.map((c, index) => (
    <tr key={c.id}>
      <td>{index + 1}</td>

      <td>
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleEdit(c)}
        >
          <AiOutlineEdit />
        </button>
      </td>

      <td>{c.setting_key}</td>
      <td>{c.description}</td>
      <td>{c.value}</td>

      <td>
        {Number(c.checked) === 1 ? (
          <span className="badge bg-success">Active</span>
        ) : (
          <span className="badge bg-danger">Inactive</span>
        )}
      </td>
    </tr>
  ))}
</tbody>
          
          </table>
        </div>




      </div>
    </div>
  )
}

export default Setting
